var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00488281H513V341.988H0V-0.00488281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00488281H513V113.992H0V-0.00488281ZM0 227.991H513V341.988H0V227.991Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.565 170.992C294.565 192.015 277.522 204.3 256.499 204.3C235.476 204.3 218.434 192.015 218.434 170.992C218.434 149.969 235.477 132.926 256.5 132.926C277.523 132.926 294.565 149.969 294.565 170.992Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.565 170.991C294.565 192.014 277.522 209.057 256.499 209.057C235.476 209.057 218.433 192.014 218.433 170.991",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.712 161.479H242.229V180.516H232.712V161.479ZM270.775 161.479H280.291V180.516H270.775V161.479ZM251.737 147.204H261.254V180.512H251.737V147.204Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPf);
export default __webpack_public_path__ + "static/media/PF.7dabca51b91091b2e7196ad5cb3f2d95.svg";
export { ForwardRef as ReactComponent };